import { render, staticRenderFns } from "./TwoCol.vue?vue&type=template&id=4f7945ca"
import script from "./TwoCol.vue?vue&type=script&lang=js"
export * from "./TwoCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports